module.exports = __webpack_public_path__ + "static/media/48_B.60677d96.png";